import React from 'react';
import { FormControlLabel, Grid, TextField, FormLabel, Switch } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';

const FormAsignacion = ({ open, isAdd, data, ctl, setCargando, setMensaje, handleClose, ...props }) => {
    const {
        register,
        control,
        watch,
        formState: { errors },
        trigger
    } = useFormContext();

    // Observar el valor de fecha inicio para validar fecha fin
    const fechaInicio = watch('fechaInicioCurso');

    // Función para formatear fecha de MySQL a datetime-local input
    const formatearFechaParaInput = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        // Formato: YYYY-MM-DDTHH:mm
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
                <FormLabel sx={{ display: 'block', mb: 1 }}>Fecha Inicio</FormLabel>
                <TextField
                    label="Fecha y hora de inicio *"
                    type="datetime-local"
                    size="small"
                    fullWidth
                    InputLabelProps={{
                        shrink: true
                    }}
                    {...register('fechaInicioCurso', {
                        required: { value: true, message: 'Campo requerido' },
                        onChange: () => {
                            // Revalidar fecha fin cuando cambia fecha inicio
                            trigger('fechaFinCurso');
                        }
                    })}
                    error={Boolean(errors.fechaInicioCurso)}
                    helperText={errors.fechaInicioCurso?.message}
                    defaultValue={formatearFechaParaInput(data?.fechaInicioCurso)}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormLabel sx={{ display: 'block', mb: 1 }}>Fecha Fin</FormLabel>
                <TextField
                    label="Fecha y hora de fin *"
                    type="datetime-local"
                    size="small"
                    fullWidth
                    InputLabelProps={{
                        shrink: true
                    }}
                    {...register('fechaFinCurso', {
                        required: { value: true, message: 'Campo requerido' },
                        validate: {
                            fechaMayor: (value) => {
                                if (!value || !fechaInicio) return true;
                                const fechaInicioDate = new Date(fechaInicio);
                                const fechaFinDate = new Date(value);

                                if (fechaFinDate <= fechaInicioDate) {
                                    return 'La fecha fin debe ser mayor a la fecha inicio';
                                }
                                return true;
                            }
                        }
                    })}
                    error={Boolean(errors.fechaFinCurso)}
                    helperText={errors.fechaFinCurso?.message}
                    defaultValue={formatearFechaParaInput(data?.fechaFinCurso)}
                />
            </Grid>

            <Grid item xs={12}>
                <FormLabel sx={{ display: 'block', mb: 1 }}>Observaciones</FormLabel>
                <TextField
                    label="Observaciones"
                    size="small"
                    fullWidth
                    multiline
                    rows={4}
                    {...register('observaciones')}
                    error={Boolean(errors.observaciones)}
                    helperText={errors.observaciones?.message}
                    defaultValue={data?.observaciones || ''}
                />
            </Grid>

            <Grid item xs={12}>
                <FormLabel sx={{ display: 'block', mb: 1 }}>Estatus</FormLabel>
                <Controller
                    name="estatus"
                    control={control}
                    defaultValue={data?.estatus === '1' ? true : false}
                    render={({ field }) => (
                        <FormControlLabel
                            control={<Switch checked={field.value} onChange={(e) => field.onChange(e.target.checked)} color="primary" />}
                            label={field.value ? 'Activo' : 'Inactivo'}
                        />
                    )}
                />
            </Grid>
        </Grid>
    );
};

export default FormAsignacion;
